import { Dispatch, SetStateAction } from "react";
import {
  Stack,
  Switch,
  FormControlLabel,
  FormGroup,
  Divider,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { SettingsAccordion } from "./CompanyCard-Setting-Accordion.partial";
import { MetaData } from "../../../Login/typings/login.types";
import { useTranslation } from "react-i18next";

type OtherSettingsAccordionProps = {
  newValues: MetaData;
  setNewValues: Dispatch<SetStateAction<MetaData>>;
};
export const OtherSettingsAccordion = ({
  newValues,
  setNewValues
}: OtherSettingsAccordionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <SettingsAccordion title={t("Other Settings")}>
      <Stack spacing={2}>
        <FormGroup sx={[isMobile ? { gap: 1 } : {}]}>
          <FormControlLabel
            control={
              <Switch
                checked={newValues.calendarSyncPossible}
                onChange={(e, c) => {
                  /* istanbul ignore next */
                  setNewValues(prevState => ({
                    ...prevState,
                    calendarSyncPossible: c
                  }));
                }}
                name="calendarSyncPossible"
                slotProps={{ input: { "aria-label": "secondary checkbox" } }}
              />
            }
            label={t("calendarSyncPossible")}
          />

          <Divider sx={{ width: "100%", margin: "4px 0px 4px 0px", opacity: "0.6" }} />

          <FormControlLabel
            control={
              <Switch
                checked={newValues.hidePastBookings}
                data-testid={"enableHidePastBookings-switch"}
                onChange={(e, c) => {
                  /* istanbul ignore next */
                  setNewValues(prevState => ({
                    ...prevState,
                    hidePastBookings: c
                  }));
                }}
                name="hidePastBookings"
                slotProps={{ input: { "aria-label": "secondary checkbox" } }}
              />
            }
            label={t("enableHidePastBookings")}
          />

          <FormControlLabel
            control={
              <Switch
                checked={newValues.showBookingStatistics}
                data-testid={"enableShowBookingStatistics-switch"}
                onChange={(e, c) => {
                  /* istanbul ignore next */
                  setNewValues(prevState => ({
                    ...prevState,
                    showBookingStatistics: c
                  }));
                }}
                name="showBookingStatistics"
                slotProps={{ input: { "aria-label": "secondary checkbox" } }}
              />
            }
            label={t("enableShowBookingStatistics")}
          />

          <FormControlLabel
            control={
              <Switch
                checked={newValues.activateOfficeSafety}
                data-testid={"activateOfficeSafety-switch"}
                onChange={(e, c) => {
                  /* istanbul ignore next */
                  setNewValues(prevState => ({
                    ...prevState,
                    activateOfficeSafety: c
                  }));
                }}
                name="activateOfficeSafety"
                slotProps={{ input: { "aria-label": "secondary checkbox" } }}
              />
            }
            label={t("enableOfficeSafety")}
          />

          <FormControlLabel
            control={
              <Switch
                checked={newValues.activateBookingServices}
                data-testid={"activateBookingServices-switch"}
                onChange={(e, c) => {
                  /* istanbul ignore next */
                  setNewValues(prevState => ({
                    ...prevState,
                    activateBookingServices: c
                  }));
                }}
                name="activateBookingServices"
                slotProps={{ input: { "aria-label": "secondary checkbox" } }}
              />
            }
            label={t("enableBookingServices")}
          />
        </FormGroup>
      </Stack>
    </SettingsAccordion>
  );
};
